export default {
    menu: {
        title: 'Meny'
    },
    minside: {
        title: 'Velkommen tilbake, {0}'
    }
};
